/** @format */

import ApiBase from "@model/api-base";

class PublicInfoApi extends ApiBase {
  constructor() {
    super();
  }
  request(name, action, data = {}) {
    return this.apiPost(`/public-info/${name}/api/v1/${action}`, data);
  }
  event(name, action, data) {
    this.trigger(`${name}:${action}`, data);
  }
}

export default PublicInfoApi;
